export const COLOR_LIST = [
  '#6669fe', '#ffb749', '#ff5461', '#13c2c2', '#a452dd',
  '#3ac9f5', '#ec7faf', '#f88776', '#91cc75', '#9187eb',
];

export const HEAR_COLOR_LIST = [
  '#00FF00', '#FFA500', '#FF0000',
];
